import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';

import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';

// Ported from managed-care-ui's Layout/Versions/styles.ts. Plain styled
// components rather than styled(Flex).attrs — portal has no
// babel-plugin-styled-components, and this avoids depending on KeyDS components
// forwarding className.
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${rem(spacing.base)};

  background: ${toColorString(color.base.midnight)};
  /* Matches the expanded LeftNav width so the footer sits flush beneath it. */
  width: ${rem(spacing.base * 21)};
  box-sizing: border-box;
`;

export const LogoContainer = styled.a`
  display: flex;

  width: ${rem(spacing.base * 7)};
`;

export const Logo = styled.img`
  width: 100%;
  height: 100%;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${rem(spacing.base / 2)};

  p {
    color: ${toColorString(color.base.quarterMoon)};
    font-size: ${rem(spacing.base * 0.8)};
    margin: 0;
  }
`;

export const Links = styled.span`
  display: flex;
  flex-wrap: wrap;

  color: ${toColorString(color.base.quarterMoon)};
  font-size: ${rem(spacing.base * 0.8)};

  gap: ${rem(spacing.base * 0.2)};

  & > a:link,
  & > a:visited,
  & > button {
    border: none;
    font-size: ${rem(spacing.base * 0.8)};
    color: ${toColorString(color.base.snowWhite)};
    /* Underlined, matching managed-care-ui — verified against its rendered
       footer, where these links compute to text-decoration: underline. */
    text-decoration: underline;
  }

  /* Cookie preferences opens the Osano drawer rather than navigating, so it is a
     real button styled to sit inline with the links. managed-care-ui uses an
     anchor with href="#" and silences the a11y rule; a button is correct here
     and looks identical. */
  & > button {
    padding: 0;
    background: none;
    font-family: inherit;
    line-height: inherit;
    cursor: pointer;
  }
`;
